"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRolEchainSeries = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const isRolEchainSeries = (whatever) => (0, echain_shared_modelling_1.isWithRequired)(whatever, {
    RolEchainParts: true,
    LangerWegZeichnungsnummer: (v) => Boolean(v), // defined and NOT empty!
});
exports.isRolEchainSeries = isRolEchainSeries;
//# sourceMappingURL=RolEchainSeries.js.map